const _roleOptions = [
    { value: 'frontEnd', label: 'Front End Developer' },
    { value: 'backEnd', label: 'Back End Developer' },
    { value: 'fullStack', label: 'Full Stack Developer'},
    { value: 'uiDeveloper', label: 'UI Developer' },
    { value: 'other', label: 'Other' }
  ];

const _howDidYouOptions = [
    { value: 'friendsFamily', label: 'Friend / Family' },
    { value: 'googleSearch', label: 'Google Search' },
    { value: 'collegeEvent', label: 'College Event'},
    { value: 'facebook', label: 'Facebook' },
    { value: 'twiiter', label: 'Twitter' },
    { value: 'instagram', label: 'Instagram' },
    { value: 'article', label: 'News Article' },
    { value: 'other', label: 'Other' }
  ];

const _contactTopicOptions = [
    { value: 'course', label: 'Courses' },
    { value: 'hiring', label: 'Hiring Partnership' },
    { value: 'sponsorship', label: 'Sponsoring Opportunities' },
    { value: 'mentorship', label: 'Mentorship' },
    { value: 'careerServices', label: 'Career Services' },
    { value: 'general', label: 'General' }
];

// const _genderOptions = [
//     { value: 'female', label: 'Female' },
//     { value: 'male', label: 'Male' }
// ];

export { 
    _roleOptions as roleOptions,
    _howDidYouOptions as howDidYouOptions,
    _contactTopicOptions as contactTopicOptions
    // _genderOptions as genderOptions
}